import { render, staticRenderFns } from "./CreateCutting.vue?vue&type=template&id=0d126d0a"
import script from "./CreateCutting.vue?vue&type=script&lang=js"
export * from "./CreateCutting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports